import * as yup from "yup";
import { FormInputMeta, FormSelectInputOptionMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { BankIDInputMeta, CorporateNameInputMeta } from "../../../forms/commonMeta";

export interface IBankCardNumberGenerationMethodsFormMeta {
    bankID: FormInputMeta;
    corporateName: FormInputMeta;
  schema: any;
}

const bankCardNumberGenerationMethodsFormMeta = {} as IBankCardNumberGenerationMethodsFormMeta;

bankCardNumberGenerationMethodsFormMeta.bankID = BankIDInputMeta;

bankCardNumberGenerationMethodsFormMeta.corporateName = CorporateNameInputMeta;

bankCardNumberGenerationMethodsFormMeta.schema = yup.object().shape(getValidationSchema(bankCardNumberGenerationMethodsFormMeta));

export default bankCardNumberGenerationMethodsFormMeta;